import { render, staticRenderFns } from "./SchoolClass.vue?vue&type=template&id=95300a30&scoped=true"
import script from "./SchoolClass.vue?vue&type=script&lang=js"
export * from "./SchoolClass.vue?vue&type=script&lang=js"
import style0 from "./SchoolClass.vue?vue&type=style&index=0&id=95300a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95300a30",
  null
  
)

export default component.exports